<template>
  <div class="radish-simple-add">
    <el-form ref="form" :model="form" label-width="50px">
      <el-form-item label="姓名">
        <el-input v-model="form['姓名']" size="mini" @change="nameDup"></el-input>
        <div v-if="nameDupData.length > 0" class="radish-dup">
          <i class="el-icon-warning">同公司存在同名候选人:</i>&nbsp;
          <div v-for="ndp in nameDupData" :key="ndp.id">
            <span class="radish-link" @click="showRadish({ id: ndp.id, name: ndp['姓名'] })">{{ ndp['姓名'] }}</span>
            <span>{{ ndp['部门'] }}</span> &nbsp;&nbsp;
            <el-button round size="mini" @click="changeDepart(ndp.id)">加入部门</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="手机">
        <el-input v-model="form['手机']" size="mini" @input="showSave"></el-input>
        <div v-if="dupData.id" class="radish-dup">
          <i class="el-icon-warning">候选人已存在:</i>&nbsp;
          <span class="radish-link" @click="showRadish({ id: dupData.id, name: dupData['姓名'] })">{{
            dupData['姓名']
          }}</span>
          <span>{{ (dupData['公司'] || '-') + ' ' + (dupData['部门'] || '-') }}</span> &nbsp;&nbsp;
          <el-button round size="mini" @click="changeComDepart(dupData.id)">加入公司部门</el-button>
          <el-button round size="mini" @click="giveUp">放弃</el-button>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button v-show="isSaveShow" type="primary" size="mini" @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    company: String,
    group: String,
    department: String,
    onSave: Function,
  },
  data: function() {
    return {
      isSaveShow: true,
      form: {},
      dupData: {},
      nameDupData: [],
    }
  },
  watch: {
    company: function(newVal, oldVal) {
      this.form['公司'] = newVal
    },
    department: function(newVal, oldVal) {
      this.form['部门'] = newVal
    },
    group: function(newVal, oldVal) {
      this.form['组别'] = newVal
    },
  },
  mounted: function() {
    this.form['公司'] = this.company
    this.form['部门'] = this.department
    this.form['组别'] = this.group
  },
  methods: {
    dup: async function() {
      const dt = JSON.parse(JSON.stringify(this.form))
      dt['姓名'] = dt['姓名'] ? dt['姓名'].replace(' ', '') : ''
      if (!dt['姓名']) {
        this.$alert('请填写姓名', { showClose: false })
        return
      }
      if (dt['手机']) {
        this.nameDupData = []
        const dup = await app.service('radish').duplicate({ phone: dt['手机'] })
        if (dup.msg == 'duplicate') {
          this.dupData = dup.data
          this.isSaveShow = false
          return false
        } else {
          this.dupData = {}
          return true
        }
      } else {
        return true
      }
    },
    nameDup: async function() {
      const dt = JSON.parse(JSON.stringify(this.form))
      const dup = await app.service('radish').duplicate({ name: dt['姓名'], company: dt['公司'] })
      if (dup.msg == 'duplicate') {
        this.nameDupData = dup.data
        return false
      } else {
        this.nameDupData = []
        return true
      }
    },
    onSubmit: async function() {
      // console.log(this.form)
      const ndup = await this.dup()
      if (!ndup) {
        return false
      }
      await this.save()
    },
    save: async function() {
      const dt = JSON.parse(JSON.stringify(this.form))
      dt.from = 'simpleAdd'
      const result = await app.service('radish').insert(dt)
      if (result.status == 'success') {
        await app.service('misc').insertBussinessAssistTask({
          type: '新建人选',
          data: { radishId: result.data.id, 姓名: dt.姓名 },
        })
        this.reset()
        if (this.onSave) {
          this.onSave({ status: 'success', data: dt })
        }
      } else {
        this.$message.error(result.msg)
      }
    },
    giveUp: function() {
      this.reset()
      if (this.onSave) {
        this.onSave({ status: 'giveup' })
      }
    },
    changeDepart: async function(id) {
      const radish = await app.service('radish').findCurrentCompany({ _id: id })
      if (radish.status == 'success') {
        const eRes = await app.service('radish').modifyById({
          _id: radish.data[0]._id,
          data: { 部门: this.form['部门'], 组别: this.form['组别'] },
        })
        if (eRes.status == 'success') {
          const dt = radish
          dt['部门'] = this.form['部门']
          this.reset()
          if (this.onSave) {
            this.onSave({ status: 'success', data: dt })
          }
        } else {
          this.$message.error(eRes.msg)
        }
      } else {
        this.$message.error(radish.msg)
      }
    },
    changeComDepart: async function(id) {
      const radish = await app.service('radish').findCurrentCompany({ _id: id })
      const dt = JSON.parse(JSON.stringify(this.form))
      if (radish.status == 'success' && radish.data.length > 0) {
        const r0 = radish.data[0]
        if (r0['公司'] && r0['公司'] == dt['公司']) {
          const res = await app
            .service('radish')
            .modifyById({ _id: r0._id, data: { 部门: dt['部门'], 组别: dt['组别'] } })
          if (res.status == 'success') {
            const d = r0
            d['部门'] = dt['部门']
            this.reset()
            if (this.onSave) {
              this.onSave({ status: 'success', data: d })
            }
          } else {
            this.$message.error(res.msg)
          }
        } else {
          const edt = {
            公司: dt['公司'],
            部门: dt['部门'],
            组别: dt['组别'],
          }
          const res = await app.service('radish').modifyById({ _id: r0._id, data: edt })
          if (res.status == 'success') {
            const d = {
              _id: r0._id,
              姓名: r0['姓名'],
              手机: r0['手机'],
            }
            d['公司'] = dt['公司']
            d['部门'] = dt['部门']
            this.reset()
            if (this.onSave) {
              this.onSave({ status: 'success', data: d })
            }
          } else {
            this.$message.error(res.msg)
          }
        }
      } else {
        this.$message.error(radish.msg)
      }
    },
    reset: function() {
      this.isSaveShow = true
      this.form['姓名'] = ''
      this.form['手机'] = ''
      this.dupData = {}
      this.nameDupData = []
    },
    showSave: function() {
      this.isSaveShow = true
      this.dupData = {}
    },
    showRadish: function(params) {
      const { id, name } = params
    },
  },
}
</script>
